import type { TBenchmarkingCounts, TBenchmarkingRates } from './types';

export const calculateRates = (
  counts?: TBenchmarkingCounts,
): TBenchmarkingRates => {
  const recommendations = counts?.recommendations;
  const previousRecommendations = counts?.previousRecommendations;

  return {
    completedProduction: counts?.completedProduction,
    previousCompletedProduction: counts?.previousCompletedProduction,
    opportunity:
      (recommendations?.unplanned ?? 0) + (recommendations?.planned ?? 0),
    previousOpportunity:
      (previousRecommendations?.unplanned ?? 0) +
      (previousRecommendations?.planned ?? 0),
    plannedRate: recommendations?.total
      ? (recommendations?.planned +
          recommendations?.scheduled +
          recommendations?.completed) /
        recommendations?.total
      : undefined,
    acceptanceRate:
      recommendations?.planned ||
      recommendations?.scheduled ||
      recommendations?.completed
        ? (recommendations?.scheduled + recommendations?.completed) /
          (recommendations?.planned +
            recommendations?.scheduled +
            recommendations?.completed)
        : undefined,
    completionRate:
      recommendations?.scheduled || recommendations?.completed
        ? recommendations?.completed /
          (recommendations?.scheduled + recommendations?.completed)
        : undefined,
    conversionRate: recommendations?.total
      ? recommendations?.completed / recommendations?.total
      : undefined,
    viewedRate: recommendations?.total
      ? recommendations?.viewedInVidea / recommendations?.total
      : undefined,
    previousPlannedRate: previousRecommendations?.total
      ? (previousRecommendations?.planned +
          previousRecommendations?.scheduled +
          previousRecommendations?.completed) /
        previousRecommendations?.total
      : undefined,
    previousAcceptanceRate:
      previousRecommendations?.planned ||
      previousRecommendations?.scheduled ||
      previousRecommendations?.completed
        ? (previousRecommendations?.scheduled +
            previousRecommendations?.completed) /
          (previousRecommendations?.planned +
            previousRecommendations?.scheduled +
            previousRecommendations?.completed)
        : undefined,
    previousCompletionRate:
      previousRecommendations?.scheduled || previousRecommendations?.completed
        ? previousRecommendations?.completed /
          (previousRecommendations?.scheduled +
            previousRecommendations?.completed)
        : undefined,
    previousConversionRate: previousRecommendations?.total
      ? previousRecommendations?.completed / previousRecommendations?.total
      : undefined,
    previousViewedRate: previousRecommendations?.total
      ? previousRecommendations?.viewedInVidea / previousRecommendations?.total
      : undefined,
  };
};
